// extracted by mini-css-extract-plugin
export default {"btn":"LinkButton_btn__E4S3I"};